import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect, useContext } from 'react';
import { ApiService } from "../services/apiServices";
import DataContext from "../context";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Autocomplete from 'react-google-autocomplete';
import { ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
const AddressModal = () => {
  const contextValues = useContext(DataContext)
  const [isLoading, setisLoadning] = useState(false);
  const [suburbs, setSuburbs] = useState([]);

  const addressModal = () => {
    contextValues.setToggleAddressModal(!contextValues.toggleAddressModal)
  }

  const onInputChange = (e) => {
    const { name, value } = e.target;
    contextValues.setUserAddressDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (value !== '') {
      e.target.style.border = '';
    }
    if (name == 'ua_pincode' && value.length === 4) {
      getSuburbs(value)
    }
  }

  useEffect(() => {
    if (contextValues.userAddressDetails.ua_id > 0) {
      getSuburbs(contextValues.userAddressDetails.ua_pincode)
      contextValues.setUserAddressDetails({
        ua_id: contextValues.userAddressDetails.ua_id,
        ua_name: contextValues.userAddressDetails.ua_name,
        ua_email: contextValues.userAddressDetails.ua_email,
        ua_mobile: contextValues.userAddressDetails.ua_mobile,
        ua_state_name: contextValues.userAddressDetails.ua_state_name,
        ua_city_name: contextValues.userAddressDetails.ua_city_name,
        ua_address_type: contextValues.userAddressDetails.ua_address_type,
        ua_address_type_other: contextValues.userAddressDetails.ua_address_type_other,
        ua_house_no: contextValues.userAddressDetails.ua_house_no,
        ua_pincode: contextValues.userAddressDetails.ua_pincode,
        ua_suburb: contextValues.userAddressDetails.ua_suburb,
        ua_suburb_id: contextValues.userAddressDetails.ua_suburb_id,
        ua_user_id: contextValues.userAddressDetails.ua_user_id,
        ua_default_address: contextValues.userAddressDetails.ua_default_address,
        ua_floor: contextValues.userAddressDetails.ua_floor,
        ua_country_id: contextValues.userAddressDetails.ua_country_id,
        ua_country_name: contextValues.userAddressDetails.ua_country_name,
        ua_latitude: contextValues.userAddressDetails.ua_latitude,
        ua_longitude: contextValues.userAddressDetails.ua_longitude,
        ua_complete_address: contextValues.userAddressDetails.ua_complete_address,
        ua_how_to_reach: contextValues.userAddressDetails.ua_how_to_reach,
      });
    } else {
      contextValues.setUserAddressDetails({
        ua_id: 0,
        ua_name: "",
        ua_email: "",
        ua_mobile: "",
        ua_state_name: "",
        ua_city_name: "",
        ua_address_type: "Home",
        ua_address_type_other: "",
        ua_house_no: "",
        ua_pincode: "",
        ua_suburb: "",
        ua_suburb_id: 0,
        ua_user_id: "",
        ua_default_address: "",
        ua_floor: "",
        ua_country_id: 13,
        ua_country_name: "Australia",
        ua_latitude: "",
        ua_longitude: "",
        ua_complete_address: "",
        ua_how_to_reach: "",
      });

    }
  }, []);

  const handleAddressProcess = () => {
    let counter = 0;
    const myElements = document.getElementsByClassName("required");
    for (let i = 0; i < myElements.length; i++) {
      if (myElements[i].value === "") {
        myElements[i].style.border = "1px solid red";
        counter++;
      } else {
        myElements[i].style.border = "";
      }
    }
    if (counter === 0) {
      if (contextValues.userAddressDetails.ua_suburb_id == '') {
        toast.error('Please Choose Suburbs');
        return;
      }
      if (contextValues.userAddressDetails.ua_house_no == '') {
        toast.error('Please Enter  House/Flat Number');
        return;
      }
      if (contextValues.userAddressDetails.ua_address_type === "") {
        toast.error("Please Select Address type");
        return false;
      }
      if (contextValues.userAddressDetails.ua_address_type === "Other") {
        if (contextValues.userAddressDetails.ua_address_type_other === "") {
          toast.error("Please Enter Other");
          return false;
        }
      }
      setisLoadning(true);
      ApiService.postData('user-address-processnew', contextValues.userAddressDetails).then((res) => {
        if (res.status === 'success') {
          localStorage.setItem('SELECTED_ADDRESS', JSON.stringify(res.userAddress));
          contextValues.setSelectedAddress(res.userAddress)
          contextValues.setAddressList(res.userAddressList)
          setisLoadning(false)
          toast.success(res.message);
          contextValues.setUserAddressDetails({
            ua_id: 0,
            ua_name: "",
            ua_email: "",
            ua_mobile: "",
            ua_state_name: "",
            ua_city_name: "",
            ua_address_type: "Home",
            ua_address_type_other: "",
            ua_house_no: "",
            ua_pincode: "",
            ua_suburb: "",
            ua_suburb_id: 0,
            ua_user_id: "",
            ua_default_address: "",
            ua_floor: "",
            ua_country_id: 13,
            ua_country_name: "Australia",
            ua_latitude: "",
            ua_longitude: "",
            ua_complete_address: "",
            ua_how_to_reach: "",
          });
          addressModal();
        } else if (res.status === 'error') {
          setTimeout(() => {
            setisLoadning(false)
          }, 500)
          toast.error(res.message);

        } else if (res.status === 'session_expired') {
          localStorage.removeItem('USER_TOKEN')
          toast.error(res.message);
          setTimeout(() => {
            window.location.href = '/'
          }, 500);
        } else {
          toast.error(res.message);
          setTimeout(() => {
            setisLoadning(false)
          }, 1000)
        }
      }).catch(() => {
        setTimeout(() => {
          setisLoadning(false)
        }, 1000)
      })
    }
  };

  const setAddressType = (type) => {
    contextValues.setUserAddressDetails(prevDetails => ({
      ...prevDetails,
      ua_address_type: type,
    }));
  }

  const handleSelect = async (placeDetails) => {
    try {
      if (!placeDetails.geometry) {
        console.error('Invalid place details');
        return;
      }

      const lat = placeDetails.geometry.location.lat();
      const lng = placeDetails.geometry.location.lng();
      const addressComponents = placeDetails.address_components || [];
      const formattedAddress = placeDetails.formatted_address || '';

      const getAddressComponent = (type) =>
        addressComponents.find((comp) => comp.types.includes(type))?.long_name || '';

      const city = getAddressComponent("locality") || getAddressComponent("administrative_area_level_2");
      const state = getAddressComponent("administrative_area_level_1");
      const country = getAddressComponent("country");
      const postalCode = getAddressComponent("postal_code");

      const cityExistData = {
        cities_name: city,
        state_name: state,
        country_name: country,
        postal_code: postalCode,
        complete_address: formattedAddress,
        lat,
        lng,
      };
      getSuburbs(cityExistData.postal_code)
      contextValues.setUserAddressDetails((prevDetails) => ({
        ...prevDetails,
        ua_latitude: cityExistData.lat,
        ua_longitude: cityExistData.lng,
        ua_city_name: cityExistData.cities_name,
        ua_complete_address: cityExistData.complete_address,
        ua_state_name: cityExistData.state_name,
        ua_pincode: cityExistData.postal_code,
      }));
    } catch (error) {
      console.error('Error fetching place details:', error);
    }
  };

  const onClose = () => {
    contextValues.setToggleAddressModal(!contextValues.toggleAddressModal)
  }

  const getSuburbs = (postcode) => {
    const postData = {
      postcode: postcode
    }
    setisLoadning(true);
    ApiService.postData('getSuburbs', postData).then((res) => {
      if (res.status === 'success') {
        setSuburbs(res.resSuburbsList)
        setisLoadning(false)
      } else if (res.status === 'error') {
        setisLoadning(false)
        toast.error(res.message);
      } else if (res.status === 'session_expired') {
        localStorage.removeItem('USER_TOKEN')
        toast.error(res.message);
        setTimeout(() => {
          window.location.href = '/'
        }, 500);
      } else {
        setisLoadning(false)
        toast.error(res.message);
      }
    }).catch(() => {
      setTimeout(() => {
        setisLoadning(false)
      }, 1000)
    })
  }
  return (
    <Modal show={contextValues.toggleAddressModal} onHide={addressModal} className="bottom">
      <ModalHeader>
        <div className="d-flex align-items-center justify-content-between" style={{width: '100%'}}>
          <h6 className="mb-0">{contextValues.userAddressDetails.ua_id > 0 ? 'Update Address' : 'Add New Address'}</h6>
          <button type="button" className="btn" onClick={() => { onClose() }}><i className="ri-close-line"></i></button>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-lg-12">
            <div className="form-group mb-15" >
              <label>Enter Your Address</label>
              <Autocomplete
                apiKey={'AIzaSyAE7oxhbgUxiIzikhCeN6TB6UUe1frQnZs'}
                onPlaceSelected={handleSelect}
                onChange={(e) => { onInputChange(e) }}
                name='ua_complete_address'
                value={contextValues.userAddressDetails.ua_complete_address}
                options={{
                  componentRestrictions: { country: "AU" } // Restrict to Australia
                }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className='form-group mb-15'>
              <label>Postal Code</label>
              <input type='text' className='required' name="ua_pincode" value={contextValues.userAddressDetails.ua_pincode} onChange={(e) => onInputChange(e)}></input>
            </div>
          </div>
          <div className="col-lg-6">
            <div className='form-group mb-15'>
              <label>Suburbs</label>
              <select className='required' name="ua_suburb_id" value={contextValues.userAddressDetails.ua_suburb_id} onChange={(e) => onInputChange(e)}>
                <option valie="">Select Suburbs</option>
                {suburbs.map((suburb) => (
                  <option key={suburb.location_id} value={suburb.location_id}>
                    {suburb.location_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-lg-6">
            <div className='form-group mb-15'>
              <label>House/Flat Number</label>
              <input type='text' className='required' name="ua_house_no" value={contextValues.userAddressDetails.ua_house_no} onChange={(e) => onInputChange(e)}></input>
            </div>
          </div>
          <div className="col-lg-6">
            <div className='form-group mb-15'>
              <label>Floor (Optional)</label>
              <input type='text' name="ua_floor" value={contextValues.userAddressDetails.ua_floor} onChange={(e) => onInputChange(e)}></input>
            </div>
          </div>
          <div className="col-lg-12">
            <div className='form-group mb-15'>
              <label>How to reach (Optional)</label>
              <input type='text' name="ua_how_to_reach" value={contextValues.userAddressDetails.ua_how_to_reach} onChange={(e) => onInputChange(e)}></input>
            </div>
          </div>
          <div className="col-lg-12">
            <div className='form-group mb-15'>
              <label className="mb-2">Save as</label>
              <ul>
                <li className={contextValues.userAddressDetails.ua_address_type === "Home" ? "active" : ""} onClick={(e) => setAddressType("Home")}>Home</li>
                <li className={contextValues.userAddressDetails.ua_address_type === "Work" ? "active" : ""} onClick={(e) => setAddressType("Work")}>Work</li>
                <li className={contextValues.userAddressDetails.ua_address_type === "Other" ? "active" : ""} onClick={(e) => setAddressType("Other")}>Other</li>
              </ul>
            </div>
          </div>
          <div className="col-lg-12">
            {contextValues.userAddressDetails.ua_address_type === 'Other' &&
              <div className='form-group mb-15'>
                <input type='text' name="ua_address_type_other" value={contextValues.userAddressDetails.ua_address_type_other} onChange={(e) => onInputChange(e)} placeholder="Eg. John’s home, Mom’s place, etc."></input>
              </div>
            }
          </div>

        </div>
      </ModalBody>
      <ModalFooter>
        <button type="button" onClick={(e) => { handleAddressProcess(e) }} className="btn btn-primary btn-full btn-lg" disabled={isLoading}>{isLoading ? <img loading="lazy" src="/img/loder01.gif" alt="Loading..." width="90" height="15" /> : 'Save'}</button>
      </ModalFooter>
    </Modal >
  )
}
export default AddressModal;
